import styled from 'styled-components'
import React, { useState, useEffect } from 'react';

import Back from '../reusable/Back'
import Next from '../reusable/Next'
import ProgressBar from '../reusable/ProgressBar'


const Card = ({ title, subtitle, text, index, active, toggleActive, background, color, logo, boxShadow }) => {
  const [opacity, toggleOpacity] = useState(1);
 
  useEffect(() => {
    toggleOpacity(0.02)
  }, [])
  
  return(
    <Wrapper background={background} active={active === index}>
      <Left background={background}>
        <TextWrap>
          <Title color={color}>{title}</Title>
          <Text color={color}>{text}</Text>
          <SubTitle color={color}>{subtitle}</SubTitle>
        </TextWrap>
        <ProgressBarWrap>
          <Indicator marginRight={8} onClick={()=>toggleActive(active===0 ? 3 : (active-1))} color={color}>0{active+1}</Indicator>
          <ProgressBar progressId={"progress1"} value={(active+1)*100/4} color={color} />
          <Indicator marginLeft={8} onClick={()=>toggleActive(active===3 ? 0 : (active+1))} color={color}>04</Indicator>
        </ProgressBarWrap>
      </Left>
      <Right boxShadow={boxShadow} background={background}>
        <ProgressBarWrap2>
          <Indicator marginRight={8} onClick={()=>toggleActive(active===0 ? 3 : (active-1))} color={color}>0{active+1}</Indicator>
          <ProgressBar progressId={"progress2"} value={(active+1)*100/4} color={color} />
          <Indicator marginLeft={8} onClick={()=>toggleActive(active===3 ? 0 : (active+1))} color={color}>04</Indicator>
        </ProgressBarWrap2>
        <Red onClick={()=>toggleActive(0)} opacity={opacity} active={active === 0} />
        <Blue onClick={()=>toggleActive(1)} opacity={opacity} active={active === 1} />
        <Yellow onClick={()=>toggleActive(2)} opacity={opacity} active={active === 2} />
        <Black onClick={()=>toggleActive(3)} opacity={opacity} active={active === 3} />
        <ButtonWrapper>
          <Back color={color} toggleActive={toggleActive} active={active} />
          <Next color={color} toggleActive={toggleActive} active={active} />
        </ButtonWrapper>
      </Right>
    </Wrapper>
  )
}

export default Card


const Wrapper = styled.div(props => ({
  opacity: props.active ? 1 : 0,
  transition:"0.6s ease-in-out",
  top:0,
  left:0,
  width:"100%",
  height:"calc(100vh - 308px)",
  minHeight:740,
  display:"flex",
  position:"absolute",
  justifyContent:"space-between",
  margin:"0px auto",
  "@media (max-width: 650px)": {
    flexDirection:"column-reverse",
    justifyContent:"center",
    alignItems:"center",
    minHeight:640,
    height:"calc(100vh - 72px)",
  },
}));

const Left = styled.div(props => ({
  background:props.background,
  width:"calc(100% - 640px)",
  display:"flex",
  flexDirection:"column",
  justifyContent:"center",
  paddingLeft:100,
  paddingRight:40,
  "@media (max-width: 1080px)": {
    width:"calc(54% - 140px)",
  },
  "@media (max-width: 980px)": {
     paddingLeft:50,
     width:"calc(54% - 90px)",
  },
  "@media (max-width: 650px)": {
    paddingLeft:16,
    paddingRight:16,
    width:"calc(100% - 32px)",
    height:"calc(50% - 24px)",
    paddingBottom:24,
  }
}));

const Right = styled.div(props => ({
  boxShadow: props.boxShadow,
  background:props.background,
  position:"relative",
  display:"flex",
  flexDirection:"column",
  justifyContent:"center",
  alignItems:"center",
  width:500,
  "@media (max-width: 1080px)": {
    width:"46%",
  },
  "@media (max-width: 650px)": {
    width:"100%",
    height:"50%",
    justifyContent:"center",
  },
}));

const TextWrap = styled.div(props => ({

}));

const Title = styled.h2(props => ({
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "48px",
  lineHeight: "72px",
  marginTop:0,
  marginBottom:24,
  color:props.color,
  "@media (max-width: 1400px)": {
    fontSize: "54px",
    lineHeight: "85px",
  },
  "@media (max-width: 1200px)": {
    fontSize: "40px",
    lineHeight: "65px",
  },
  "@media (max-width: 880px)": {
    fontSize: "24px",
    lineHeight: "36px",
  },
}));

const SubTitle = styled.h3(props => ({
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "18px",
  color:props.color,
  "@media (max-width: 650px)": {
    marginBottom:16,
  },
}));

const Text = styled.p(props => ({
  color:props.color,
  fontWeight: "normal",
  fontSize: "14px",
  lineHeight: "21px",
  marginTop:0,
  marginBottom:48,
  maxWidth:500,
}));

const Indicator = styled.p(props => ({
  color:props.color,
  fontWeight: "normal",
  fontSize: "14px",
  cursor:"pointer",
  lineHeight: "21px",
  marginLeft:props.marginLeft,
  marginRight:props.marginRight,
}));

const Red = styled.div(props => ({
  display:props.active ? "block" : "none",
  transition:"0.2s ease-in-out",
  
  width:200,
  height:200,
  background: props.theme.colors.tertiary,
  
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25), 0px 0px 30px rgba(0, 0, 0, 0.2)",
  "@media (max-width: 650px)": {
    width:140,
    height:140,
  },
  
}));

const Blue = styled.div(props => ({
  display:props.active ? "block" : "none",
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25), 0px 0px 30px rgba(0, 0, 0, 0.2)",
  transition:"0.2s ease-in-out",
  width:200,
  height:200,
  background: props.theme.colors.primary,
  
  "@media (max-width: 650px)": {
    width:140,
    height:140,
  },
}));

const Yellow = styled.div(props => ({
  display:props.active ? "block" : "none",
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25), 0px 0px 30px rgba(0, 0, 0, 0.2)",
  transition:"0.2s ease-in-out",
  width:200,
  height:50,
  background: props.theme.colors.quaternary,
  
  "@media (max-width: 650px)": {
    width:140,
    height:35,
  },
}));

const Black = styled.div(props => ({
  display:props.active ? "block" : "none",
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25), 0px 0px 30px rgba(0, 0, 0, 0.5)",
  transition:"0.2s ease-in-out",
  width:200,
  height:50,
  background: props.theme.colors.secondary,
  
  "@media (max-width: 650px)": {
    width:140,
    height:35,
  },
}));

const ButtonWrapper = styled.div(props => ({
  position:"absolute",
  bottom:100,
  display:"flex",
  "@media (max-width: 650px)": {
    bottom:36,
  },
  
}));

const ProgressBarWrap = styled.div(props => ({
  display:"flex",
  justifyContent:"space-between",
  alignItems:"center",
  position:"absolute",
  bottom:84,
  width:200,
  "@media (max-width: 650px)": {
    display:"none",
  },
}));

const ProgressBarWrap2 = styled.div(props => ({
  display:"flex",
  justifyContent:"space-between",
  alignItems:"center",
  position:"absolute",
  top:24,
  width:200,
  "@media (min-width: 651px)": {
    display:"none",
  },
}));

